import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable()
export class CoachSettingsGeneralInformationController {
	public calendarLocale$: Observable<any>;

	constructor(private _translateService: TranslateService) {
		this._initObservables();
	}

	private _initObservables() {
		this.calendarLocale$ = this._translateService.stream(
			'presentation.primeng.calendar'
		);
	}
}
